import { render, staticRenderFns } from "./emrNewPatient.vue?vue&type=template&id=db6c354c"
import script from "./emrNewPatient.vue?vue&type=script&lang=js"
export * from "./emrNewPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports